module.exports = __webpack_public_path__ + "img/venus18.0dd277bc.png";